var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBloodGlucose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "blood-glucose_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".blood-glucose_svg__st0{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-miterlimit:10}.blood-glucose_svg__st1{fill:var(--color-icon-secondary)}.blood-glucose_svg__st2{fill:none;stroke:var(--color-text);stroke-width:3;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "blood-glucose_svg__st0",
    d: "M81.9 108h5.8c5.6 0 11-1.7 15.6-4.8l4.3-2.9c.7-.5.9-1.4.5-2.1-.7-1-1.6-1.8-2.4-2.3-2.1-1.2-4.6-1.1-6.8-.1-7.9 3.9-14.9.6-14.9.6-2.6-1.6-5-2.8-7.3-3.8-9.8-4-20.9-2.5-29.5 3.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "blood-glucose_svg__st0",
    d: "M47.1 116.8s13.2-2.6 36.3-1.2c6.1.3 12.2-1 17.6-3.9l35-18.6c.8-.4 1-1.4.4-2.1-1.3-1.6-4.1-3.8-9.8-2.3-.6.2-1.3.4-1.9.7L107.1 97M33.8 125.2h13V91.7h-13"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "blood-glucose_svg__st1",
    d: "M11.2 81.9h22.5v52.2H11.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "blood-glucose_svg__st2",
    d: "M131.4 63H96.8c-3 0-5.4-2.4-5.4-5.4V19.3c0-3 2.4-5.4 5.4-5.4h34.6c3 0 5.4 2.4 5.4 5.4v38.4c0 2.9-2.4 5.3-5.4 5.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "blood-glucose_svg__st0",
    d: "M101.5 51.5h7.5M119.1 51.5h7.5M117.7 68.1v6.7h-9.4v-6.7M113 74.8v9.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 22.9v22.3c7.3-17.2 25.1-16.9 25.1-16.9v-5.4h-25.1z",
    fill: "var(--color-icon-primary)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "blood-glucose_svg__st2",
    d: "M68.5 48.4c0-7.3-13.3-25.6-13.3-25.6S41.9 41.1 41.9 48.4s6 13.3 13.3 13.3 13.3-5.9 13.3-13.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "blood-glucose_svg__st1",
    d: "M58.4 38.3c.3 1.2.5 2.2.5 3.1 0 5.9-3.8 10.8-9 12.6 1.4 1.3 3.2 2.1 5.2 2.1 4.2 0 7.7-3.4 7.7-7.7 0-1.7-1.8-5.6-4.4-10.1z"
  })));
}
export default SvgBloodGlucose;